import dayjs from "dayjs";
import moment from "moment";

export const getPickerDate = (date) => {
  if (!date) {
    return null;
  }

  if (date instanceof Date) {
    return date;
  }

  if (moment.isMoment(date)) {
    return date.toDate();
  }

  if (dayjs.isDayjs(date)) {
    return date.toDate();
  }

  if (date._d instanceof Date) {
    return date._d;
  }

  return null;
};

export const getPickerMoment = (date) => {
  const pickerDate = getPickerDate(date);
  return pickerDate ? moment(pickerDate) : null;
};

export const toAntPickerDate = (value, format) => {
  if (!value) {
    return null;
  }

  if (dayjs.isDayjs(value)) {
    return value;
  }

  if (moment.isMoment(value)) {
    return dayjs(value.toDate());
  }

  if (value instanceof Date) {
    return dayjs(value);
  }

  const parsedMoment = format
    ? moment(value, format, true)
    : moment(value);

  if (parsedMoment.isValid()) {
    return dayjs(parsedMoment.toDate());
  }

  return null;
};
